/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Scan_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add cards to a collection with your camera" |
*
* @param {Nav_Scan_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_scan_description = /** @type {((inputs?: Nav_Scan_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Scan_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Karten mit deiner Kamera in eine Sammlung aufnehmen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajoutez des cartes à une collection avec votre caméra")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("用摄像头把卡牌加入收藏")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("用相機把卡牌加入收藏")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카메라로 카드를 컬렉션에 추가")
	return /** @type {LocalizedString} */ ("Add cards to a collection with your camera")
});